export default __webpack_public_path__ + "static/media/icons8-x.dc3f1229.svg";